<div *transloco="let t; read: 'notes-editor'" class="xi-modal__container notes-editor__container">
  <h2 class="xi-modal__title">{{ t('notes') }}</h2>

  <form [formGroup]="form" class="xi-modal__content">
    <xi-text-area
      formControlName="notes"
      [height]="200"
      [resize]="false"
      type="text"
    ></xi-text-area>
  </form>

  <div class="xi-modal__actions notes-editor__actions">
    <xi-default-button [text]="t('cancel')" fill="text" (onClick)="onCancel()"></xi-default-button>

    <xi-default-button
      [text]="t('save')"
      [disabled]="!hasChanges"
      (onClick)="onSave()"
    ></xi-default-button>
  </div>
</div>
